import React, { useState } from "react";

/* The reward pool, demonstrated rather than described.
 *
 * This is the mechanic clients get wrong most often when they hear it in
 * words, so it is worth being able to press. Sixty codes. Send every guest a
 * claim link and nothing moves. Only the ones a real person opens actually
 * leave, and the rest are still there afterwards.
 *
 * No performance claim anywhere in it: the visitor chooses how many links get
 * opened, and the only numbers on screen are the consequences of that choice. */

const TOTAL = 60;

const STEPS = [
  {
    id: 0,
    cta: "Send all 60 a claim link",
    line: "Sixty codes loaded. Nothing has been given away yet.",
  },
  {
    id: 1,
    cta: "Now let 17 of them open it",
    line:
      "Sixty links sent, including to the address somebody made up at the bar. The pool has not moved.",
  },
  {
    id: 2,
    cta: "Start again",
    line:
      "Seventeen codes gone, assigned at the moment a real person opened their link. The other 43 are still yours.",
  },
];

export default function Pool() {
  const [step, setStep] = useState(0);
  const claimed = step >= 2 ? 17 : 0;
  const sent = step >= 1;

  return (
    <div className="pool">
      <div className="pool__top">
        <span className="micro">Reward pool</span>
        <span className="pool__count mono">
          {TOTAL - claimed}
          <em> / {TOTAL}</em>
        </span>
      </div>

      <div className="pool__grid" aria-hidden="true">
        {Array.from({ length: TOTAL }, (_, i) => (
          <span
            key={i}
            className="pool__chip"
            data-state={i < claimed ? "gone" : sent ? "sent" : "held"}
            style={{ "--d": `${(i % 20) * 26}ms` }}
          />
        ))}
      </div>

      <p className="pool__line">{STEPS[step].line}</p>

      <button
        type="button"
        className="btn btn--ghost btn--sm pool__btn"
        onClick={() => setStep((s) => (s + 1) % STEPS.length)}
      >
        {STEPS[step].cta}
      </button>
    </div>
  );
}
